module.exports = __webpack_public_path__ + "static/media/hormasport.00b7d20b.png";